import { queryOpportunities } from '@/services/bff/opportunity.api';
import type {
  CustomerDrawerOpportunityItem,
  CustomerDrawerRelatedPage,
} from '@/services/bff/types/customer';
import type { OpportunityViewMode } from '@/services/bff/types/opportunity';

export async function queryCustomerOpportunityPage(
  customerUuid: string,
  viewMode: OpportunityViewMode,
): Promise<CustomerDrawerRelatedPage<CustomerDrawerOpportunityItem>> {
  const data = await queryOpportunities({
    customerUuid,
    viewMode,
    page: 1,
    pageSize: 20,
  });

  return {
    list: (data.list || []).map((item) => ({
      ...item,
      name: item.name || '',
    })),
    total: data.total || 0,
  };
}
